import React, { useState, useEffect } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";

// import JS files
import TableIconModal from "../../shares/TableIconModal";
import OrderCardLeftPart from "./OrderCardLeftPart";
import CreateOrderCard from "../../shares/CreateOrderCard";
import POrderCardLeftPart from "../../admin-panels/producers/create-order-new/POrderCardLeftPart";

const AddRingTabThree = (props) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<AddCircleIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <CreateOrderCard ring={props.selectedRow}>
          {props.producerCreateOrder ? (
            <POrderCardLeftPart
              needDefaultValue
              item={props.selectedRow}
              hasOpenModal
              setOpenModal={setOpenModal}
              selectedUser={props.selectedUser}
              producerCreateOrder={props.producerCreateOrder}
              // update_admin_producer_ring_nums={props.update_admin_producer_ring_nums}
            />
          ) : (
            <OrderCardLeftPart
              item={props.selectedRow}
              hasOpenModal
              setOpenModal={setOpenModal}
              selectedUser={props.selectedUser}
            />
          )}
        </CreateOrderCard>
      </TableIconModal>
    </>
  );
};

export default AddRingTabThree;
